import { audienceCards } from "@/data/content";

export default function Audience() {
  return (
    <section id="audience" className="py-20 md:py-28 bg-[var(--aura-ivory-2)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl">
          <span className="eyebrow">Who Aura Is For</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
            Whether joining, booking, or partnering — Aura is designed for you
          </h2>
          <p className="mt-5 font-body text-[var(--aura-charcoal-2)] leading-relaxed">
            Whether you are joining as a participant, booking for your team, or
            collaborating as a partner, Aura is designed to make events feel
            more intentional, useful, and memorable.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          {audienceCards.map((a) => (
            <span
              key={a.title}
              className="inline-flex items-center gap-2 font-ui text-sm px-4 py-2.5 rounded-full bg-white border border-black/5"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--aura-teal)]" />
              {a.title}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
